export default __webpack_public_path__ + "static/112-b7d3babdc164d6cb6c98143715e32b53.jpg";